// Discipline catalog — codes used across the app
export const DISCIPLINES = [
  { code: "OT", label: "OT", full: "Occupational Therapist" },
  { code: "ST", label: "ST", full: "Speech Therapist" },
  { code: "PT", label: "PT", full: "Physical Therapist" },
  { code: "COTA", label: "COTA", full: "Certified Occupational Therapy Assistant" },
  { code: "PTA", label: "PTA", full: "Physical Therapist Assistant" },
];

export const DISCIPLINE_CODES = DISCIPLINES.map((d) => d.code);

// Assistants share the same phrase library as the supervising discipline
export const PHRASE_DISCIPLINE_ALIAS = {
  COTA: "OT",
  PTA: "PT",
};

export const DISC_FULL = Object.fromEntries(DISCIPLINES.map((d) => [d.code, d.full]));
export const DISC_LABEL = Object.fromEntries(DISCIPLINES.map((d) => [d.code, d.label]));
